import { render, staticRenderFns } from "./UnidadAdministrativa.vue?vue&type=template&id=7fc5ce40&"
import script from "./UnidadAdministrativa.vue?vue&type=script&lang=js&"
export * from "./UnidadAdministrativa.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports